import type { DateOnly } from "@/shared/components/date-picker";
import { getMomentTz } from "@dexteel/mesf-core";

const moment = getMomentTz();

export interface BillPeriod {
	billId: number;
	start: Date;
	end: Date;
}

export const formatBillingDate = (value: Date | null) =>
	value === null ? "" : moment.utc(value).format("MM/DD/YY");

export const getBilledDays = (periods: BillPeriod[]): Map<DateOnly, number> => {
	const days = new Map<DateOnly, number>();
	for (const period of periods) {
		const day = moment.utc(period.start);
		const end = moment.utc(period.end);
		while (day.isSameOrBefore(end, "day")) {
			days.set(day.format("YYYY-MM-DD"), period.billId);
			day.add(1, "day");
		}
	}
	return days;
};

export const isDateBilled = (
	periods: BillPeriod[],
	date: Date | null,
	exceptBillId: number | null,
) =>
	date !== null &&
	periods.some(
		(period) =>
			period.billId !== exceptBillId &&
			date.getTime() >= period.start.getTime() &&
			date.getTime() <= period.end.getTime(),
	);

export const findOverlappingPeriod = (
	periods: BillPeriod[],
	start: Date | null,
	end: Date | null,
	exceptBillId: number | null,
): BillPeriod | null => {
	if (start === null || end === null) return null;
	return (
		periods.find(
			(period) =>
				period.billId !== exceptBillId &&
				period.start.getTime() <= end.getTime() &&
				period.end.getTime() >= start.getTime(),
		) ?? null
	);
};
